<template>
  <div class="product-page">
    <div class="product-page-wrapper">
      <div class="main-title">
        <button @click="goBack">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_12_1247)">
              <path
                d="M2.57958 5.99997C2.57958 5.7849 2.6617 5.56987 2.82559 5.4059L7.98537 0.24617C8.3136 -0.0820566 8.84576 -0.0820566 9.17385 0.24617C9.50195 0.574263 9.50195 1.10632 9.17385 1.43457L4.60819 5.99997L9.17369 10.5654C9.50179 10.8936 9.50179 11.4256 9.17369 11.7537C8.8456 12.0821 8.31344 12.0821 7.98521 11.7537L2.82543 6.59404C2.66151 6.42999 2.57958 6.21495 2.57958 5.99997Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_12_1247">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <div class="title extrasmall">
          <b>{{ $t("Back to CS2 market") }}</b>
        </div>
      </div>
      <div class="product-details-container" v-if="product">
        <div class="product-image-container">
          <img src="./../assets/img/logo3.svg" alt="logo3" class="logo3" />
          <img
            :src="product?.image_url || imgDomain + product?.img_url"
            :alt="product?.name || product?.title"
            class="product-image"
          />
          <div v-if="product?.id === chosenItem" class="added-inscription">
            {{ $t(`Added`) }}
          </div>
        </div>
        <div class="product-info-container">
          <div class="product-info-wrapper">
            <h1 class="title product-title text-white">
              {{ product?.name || product?.title }}
            </h1>

            <div class="row">
              <div class="column">
                <div class="desc small text-white opacity-50">
                  {{ product?.type }}
                </div>
              </div>
              <!-- <div class="column">
                <div class="desc tiny">
                  {{ $t("Quality:") }}
                </div>
                <div class="desc small text-white">
                  {{ product?.quality }}
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="title product-price text-white">
                {{ product.price }}
                <span class="text-red">{{ currencySymbol }}</span>
                <div v-if="hasDiscount" class="discount-badge">
                  <img
                    src="./../assets/img/discount-icon.svg"
                    alt="Discount"
                    class="discount-icon"
                  />
                </div>
              </div>
              <button
                type="button"
                class="button w-240 red"
                @click="addToCart(product)"
              >
                <span>{{ $t(`Buy`) }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!product && !productLoading" class="no-product">
        {{ $t("Product not found") }}
      </div>
    </div>
    <ProductCarousel
      v-if="product?.similar && product.similar.length > 0"
      :title="$t(`Similar Products`)"
      :chosenItem="chosenItem"
      showArrows="true"
      @goToProduct="goToProduct"
      @addToCart="addToCart"
      :background="'none'"
      :initialProducts="product?.similar"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Chart, registerables } from "chart.js";
import ProductCarousel from "@/components/ProductCarousel.vue";

Chart.register(...registerables);

export default {
  name: "ProductPage",
  components: {
    ProductCarousel,
  },
  props: {
    // type: {
    //     type: String,
    // },
    id: {
      type: String,
    },
    chosenItem: {
      type: String,
    },
  },
  data() {
    return {
      product: null,
      chart: null,
      // chartData: [],
      imgDomain: "",
      productLoading: true,
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode", "currencySymbol"]),
    ...mapGetters("cart", ["cartContents"]),
    hasDiscount() {
      return (
        this.product &&
        this.product.old_price &&
        this.product.old_price !== "0.00"
      );
    },
  },
  created() {
    this.fetchProductData();
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  watch: {
    id() {
      this.fetchProductData();
    },
    currencyCode() {
      this.fetchProductData();
    },
    // chartData(newData) {
    //     if (newData.length > 0) {
    //         this.createChart();
    //     }
    // },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    generateBreadcrumbs() {
      if (!this.product) return [];

      return [
        // {
        //     text: this.product.category,
        //     link: `/products/${this.product.category}`,
        // },
        {
          text: this.product.type,
          link: `/products/${this.product.type}`,
        },
        {
          text: this.product.title,
          link: `/product/${this.product.id}`,
        },
      ];
    },
    addToCart(item) {
      const itemAlreadyInCart = this.cartContents.some(
        (cartItem) => cartItem.item_id === item.id,
      );

      if (itemAlreadyInCart) {
        this.$toast.info(this.$t("This item is already in your cart."));
        return;
      }
      this.$emit("addToCart", item);
    },
    fetchProductData() {
      this.productLoading = true;
      const apiEndpoint = `items/${this.id}`;
      this.$http
        .get(`${process.env.VUE_APP_API}${apiEndpoint}`, {
          params: {
            currency: this.currencyCode,
            include_price_history: true,
          },
        })
        .then((res) => {
          this.product = res.data.payload;
        })
        .catch((error) => {
          console.error("Failed to load product data:", error);
        })
        .finally(() => {
          this.productLoading = false;
        });
    },
    // createChart() {
    //     this.$nextTick(() => {
    //         const canvas = this.$refs.chartCanvas;
    //         if (canvas && this.chartData.length > 0) {
    //             this.destroyChart();
    //             const ctx = canvas.getContext('2d');

    //             this.chart = new Chart(ctx, {
    //                 type: 'line',
    //                 data: {
    //                     labels: this.chartData.map(data => data.date),
    //                     datasets: [{
    //                         label: 'Price',
    //                         data: this.chartData.map(data => data.price),
    //                         borderColor: '#15CA5C',
    //                         borderWidth: 2,
    //                         pointBackgroundColor: '#15CA5C',
    //                         pointBorderColor: '#15CA5C',
    //                         pointRadius: 0,
    //                         pointHoverRadius: 5,
    //                         tension: 0
    //                     }]
    //                 },
    //                 options: {
    //                     responsive: true,
    //                     maintainAspectRatio: false,
    //                     layout: {
    //                         padding: {
    //                             top: 16,
    //                             right: 42,
    //                             bottom: 16,
    //                             left: 16
    //                         }
    //                     },
    //                     scales: {
    //                         x: {
    //                             grid: {
    //                                 color: (context) => {
    //                                     if (context.index === 0 || context.index == this.chartData.length - 1) {
    //                                         return 'transparent';
    //                                     }
    //                                     return '#3B4858';
    //                                 },
    //                                 lineWidth: 1,
    //                                 drawBorder: false
    //                             },
    //                             border: { display: false },
    //                             ticks: {
    //                                 autoSkip: true,
    //                                 maxTicksLimit: 8,
    //                                 font: {
    //                                     family: 'Oxanium',
    //                                     size: 14,
    //                                     weight: 500
    //                                 },
    //                                 color: 'white',
    //                                 callback: (index) => {
    //                                     return this.chartData[index].date.slice(0, -4);
    //                                 }
    //                             },
    //                         },
    //                         y: {
    //                             grid: {
    //                                 color: '#3B4858',
    //                                 lineWidth: 1,
    //                                 drawBorder: false,
    //                             },
    //                             border: { display: false },
    //                             ticks: {
    //                                 font: {
    //                                     family: 'Oxanium',
    //                                     size: 14,
    //                                     weight: 500
    //                                 },
    //                                 autoSkip: false,
    //                                 count: 7,
    //                                 color: 'white',
    //                                 callback: (value, index, values) => (index == (values.length - 1) || index == 0) ? undefined : ` ${value.toFixed(2)} €`,
    //                             },
    //                             afterDataLimits: (axis) => {
    //                                 const range = axis.max - axis.min;
    //                                 const pixelValue = 31;
    //                                 const chartHeight = axis.chart.height;
    //                                 const valuePerPixel = range / chartHeight;
    //                                 const valueIncrease = pixelValue * valuePerPixel;

    //                                 axis.max += valueIncrease;
    //                                 axis.min -= valueIncrease;
    //                             }
    //                         }
    //                     },
    //                     plugins: {
    //                         legend: {
    //                             display: false
    //                         },
    //                         tooltip: {
    //                             backgroundColor: '#070B1C',
    //                             titleFont: {
    //                                 family: 'Oxanium',
    //                                 size: 14,
    //                                 weight: 500
    //                             },
    //                             bodyFont: {
    //                                 family: 'Oxanium',
    //                                 size: 14,
    //                                 weight: 500
    //                             },
    //                             padding: 10,
    //                             cornerRadius: 8,
    //                             displayColors: false,
    //                             boxPadding: 0,
    //                             callbacks: {
    //                                 title: (tooltipItems) => {
    //                                     const item = tooltipItems[0];
    //                                     return `${item.label}`;
    //                                 },
    //                                 label: (context) => {
    //                                     return `CDN ${context.parsed.y.toFixed(2)} €`;
    //                                 },
    //                                 afterLabel: (context) => {
    //                                     const dataPoint = this.chartData[context.dataIndex];
    //                                     return `${dataPoint.count} sold`;
    //                                 }
    //                             }
    //                         },
    //                     },
    //                     elements: {
    //                         point: {
    //                             radius: 1,
    //                             hoverRadius: 8,
    //                             hitRadius: 20
    //                         }
    //                     }
    //                 }
    //             });
    //         }
    //     });
    // },
    // destroyChart() {
    //     if (this.chart) {
    //         this.chart.destroy();
    //         this.chart = null;
    //     }
    // },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
  },
};
</script>

<style scoped lang="scss">
.product-carousel-section {
  padding: 60px 16px 120px;
}
.main-title {
  width: 100%;
  max-width: 1352px;
  margin: 32px auto;
  padding: 32px;
  display: flex;
  align-items: center;
  background: #191919;
  gap: 10px;
  border-radius: 12px;

  button {
    line-height: 0;
  }
}
.product-page-wrapper {
  padding: 0 16px;
}
.product-details-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  gap: 62px;
  background: #191919;
  max-width: 1072px;
  border-radius: 12px;
  padding: 46px;
  overflow: hidden;
}

.product-image-container {
  position: relative;
  max-width: 512px;
  height: 384px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  .logo3 {
    width: 325px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 452px;
  max-height: 344px;
  position: relative;
}
.row {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 40px;

  .column {
    flex: 1;

    .tiny {
      border-bottom: 1px solid #ffffff1a;
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
  }
}
.row + .row {
  flex-wrap: wrap;
}
.product-info-container {
  width: 578px;
}

.product-info-wrapper {
  width: 100%;
}

.product-title {
  margin-bottom: 14px;
}

.product-price {
  display: flex;
  align-items: center;
  gap: 10px;

  font-family: "Roboto", sans-serif;
}

.discount-badge {
  display: flex;
  align-items: center;
}

.add-to-cart-button-wrapper {
  width: 160px;
  height: 48px;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.corner-svg {
  position: absolute;
  width: 24px;
  height: 24px;
  pointer-events: none;
}

.top-left {
  top: -1px;
  left: -1px;
}

.top-right {
  top: -1px;
  right: -1px;
  transform: rotate(90deg);
}

.bottom-left {
  bottom: -1px;
  left: -1px;
  transform: rotate(270deg);
}

.bottom-right {
  bottom: -1px;
  right: -1px;
  transform: rotate(180deg);
}

.add-to-cart-button {
  width: 152px;
  height: 40px;
  position: relative;
  background: #15ca5c;
  border: none;
  padding: 0;
  cursor: pointer;
}

.add-to-cart-button span {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 14.63px;
  color: #191919;
}

.added-inscription {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 48px;
  z-index: 10;
}

.no-product {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 20px;
  color: white;
}

@media (max-width: 768px) {
  .product-details-container {
    flex-direction: column;
    align-items: center;
    padding: 24px 16px;
    gap: 24px;
  }

  .product-image-container {
    max-width: 100%;
  }

  .product-info-container {
    width: 100%;
  }
}
</style>
